export default "__VITE_ASSET__tFbJag6O__"